<template>
  <b-container fluid>
    <b-modal id="selbstdeklarationGTmodal" :title="getTitle" size="xl">
      <b-container fluid v-if="dataLoaded">
        <!-- wizardstep 0 Grundanforderungen -->
        <div v-show="anforderungen(1).length && wizardStep === 0">
          <p v-html="paketGT.text[$i18n.locale]"></p>
          <p>{{ $t("Datenpakete_GT_GA_Einleitungssatz") }}</p>

          <div v-for="kriterium in anforderungen(1)" v-bind:key="kriterium.id">
            <selbstdeklaration-zeile
                :kriterium="kriterium"
                :kriteriumID="kriterium.id"
                :paketID="2"
            />
            <p v-if="kriterium.key === 'RAUS' && kriterium.value === 5"
               v-html="$t('Datenpakete_GT_RAUS_InfoGesuch')"></p>
            <b-card :title="$t('Datenpakete_GT_RGS_Titel')"
                    v-if="kriterium.key === 'RAUS' && kriterium.value === 7 && rgsAnmeldungErzwingen">
              <b-card-text v-html="$t('Datenpakete_GT_RGS_Einleitungssatz')"></b-card-text>
              <b-form>
                <b-form-group :label="$t('AGISP')" label-for="agisID">
                  <b-form-input id="agisID" v-model="agisID" disabled/>
                </b-form-group>
                <b-form-group :label="$t('Adresse')" label-for="adresse">
                  <b-form-input id="adresse" v-model="adresse" disabled/>
                </b-form-group>
                <b-form-group :label="$t('Email')" label-for="email">
                  <b-form-input id="email" v-model="email" disabled/>
                </b-form-group>
                <b-form-group :label="$t('Person')" label-for="person">
                  <b-form-input id="person" v-model="rgs.person" disabled/>
                </b-form-group>
                <b-form-group :label="$t('Betriebsform')" label-for="bForm">
                  <b-form-input id="bForm" v-model="rgs.bForm" disabled/>
                </b-form-group>
                <b-form-group :label="$t('MitgliedschaftFuerRGS')" label-for="mitgliedschaften">
                  <b-form-checkbox-group
                      id="mitgliedschaften"
                      name="mitgliedschaften"
                      stacked
                      v-model="rgs.mitgliedschaften"
                      :options="rgs.organisationen"
                      value-field="de"
                      :text-field="$i18n.locale"
                  ></b-form-checkbox-group>
                </b-form-group>
                <b-form-group :label="$t('Bemerkungen')" label-for="bemerkungen">
                  <b-form-textarea
                      id="bemerkungen"
                      v-model="rgs.bemerkungen"
                      placeholder="..."
                      rows="3"
                      max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group :label="$t('Bestandestierarzt') + ' *'" label-for="arzt">
                  <b-form-input id="tierarztPraxis" v-model="rgs.tierarzt.praxis" :placeholder="$t('NamePraxis')"
                                required :state="rgs.tierarzt.praxis.length > 0" class="mb-3"/>
                  <b-row>
                    <b-col cols="2">
                      <b-form-input id="tierarztPLZ" v-model="rgs.tierarzt.plz" :placeholder="$t('PLZ')" required
                                    :state="rgs.tierarzt.plz.length > 0"/>
                    </b-col>
                    <b-col cols="10">
                      <b-form-input id="tierarztOrt" v-model="rgs.tierarzt.ort" :placeholder="$t('Ort')" required
                                    :state="rgs.tierarzt.ort.length > 0"/>
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-form-checkbox id="rgsAGB" name="rgsAGB" v-model="rgs.agb" required :state="rgs.agb">
                  <p v-html="$t('Datenpakete_GT_RGS_AGB')"></p>
                </b-form-checkbox>
                <b-button :disabled="!rgs.agb || !rgs.tierarzt.praxis || !rgs.tierarzt.plz || !rgs.tierarzt.ort"
                          @click.stop="sendAnmeldungRGS()">
                  {{ $t('Datenpakete_GT_RGS_Anmelden') }}
                </b-button>
              </b-form>
            </b-card>
          </div>

          <b-alert show v-if="!anforderungenAusgefuellt(1)" variant="warning">
            {{ $t("Datenpakete_GT_GA_Allesausfuellen") }}
          </b-alert>

          <b-alert show v-if="rgsAnmeldungErzwingen" variant="danger">
            {{ $t("Datenpakete_GT_RGS_Unvollstaendig") }}
          </b-alert>

          <b-alert show v-show="anforderungen(1).length"
                   :variant="anforderungenStatus(1) === true ? 'success' : 'danger'">
            {{ anforderungenAnzahl(1) }} {{ $t("Von").toLowerCase() }} {{ anforderungenTotal(1) }}
            {{ $t("Datenpakete_GT_GA_AvonB_Zusatztext") }}
          </b-alert>
        </div>

        <!-- wizardstep 1 Zusatzanforderungen -->
        <div v-show="anforderungen(2).length && wizardStep === 1">
          <p>{{ $t("Datenpakete_GT_ZA_Einleitungssatz") }}</p>
          <div v-for="kriterium in anforderungen(2)" v-bind:key="kriterium.id">
            <selbstdeklaration-zeile
                :paketID="2"
                :kriterium="kriterium"
                :kriteriumID="kriterium.id"
                :disabled="kriterium.key === 'BTSundRAUS'"
            />
          </div>

          <template v-if="anforderungenStatus(1) === true">
            <b-alert show variant="success">{{
                $t("Datenpakete_GT_GA_Erfuellt")
              }}
            </b-alert>
          </template>
          <template v-else>
            <b-alert show variant="danger">
              {{ $t("Datenpakete_GT_GA_NichtErfuellt") }}
            </b-alert>
          </template>

          <b-alert show v-show="anforderungen(2).length"
                   :variant="anforderungenStatus(2) === true ? 'success' : 'danger'">
            {{ anforderungenAnzahl(2) }} {{ $t("Von").toLowerCase() }} {{ anforderungenTotal(2) }}
            {{ $t(anforderungenStatus(2) ? "Datenpakete_GT_ZA_Erfuellt" : "Datenpakete_GT_ZA_NichtErfuellt") }}
          </b-alert>

          <template v-if="anforderungenStatus(1) === true && anforderungenStatus(2) === true">
            <b-alert show variant="success">
              {{ $t("Datenpakete_GT_Total_Erfuellt") }}
            </b-alert>
          </template>
          <template v-else>
            <b-alert show variant="danger">
              {{ $t("Datenpakete_GT_Total_NichtErfuellt") }}
            </b-alert>
          </template>
        </div>

        <!-- wizardstep 2 Freigaben -->
        <div v-show="wizardStep === 2">
          <template v-if="anforderungenStatus(1) === true && anforderungenStatus(2) === true">
            <b-alert show variant="success">
              {{ $t("Datenpakete_GT_Total_Erfuellt") }}
            </b-alert>
          </template>
          <template v-else>
            <b-alert show variant="danger">
              {{ $t("Datenpakete_GT_Total_NichtErfuellt") }}
            </b-alert>
          </template>
          <p>{{ $t("Datenpakete_GT_FG_Einleitungssatz") }}</p>

          <h3>{{ $t("Datenpakete_GT_FG_FreigabenListeTitel") }}</h3>
          <div v-for="(verwerterX, indx) in verwerter" v-bind:key="indx">
            <b-form-checkbox
                class="col-10"
                v-model="paketGT.organisationen[indx].freigabe"
                :id="'verwerter' + verwerterX.orgid"
                :disabled="verwerterX.disabled"
                v-on:change="freigabeChanged(verwerterX.orgid, indx)"
            >
              {{ verwerterX.organisation }}
              <span v-if="verwerterX.von.length">
                ({{ $t("Seit").toLowerCase() }} {{ convertTime(verwerterX.von) }})
              </span>
              <!--<br>
              von:{{ convertTime(verwerterX.von)}}
              <br>
              bis:{{convertTime(verwerterX.bis)}}
              <br>&nbsp;-->
            </b-form-checkbox>
          </div>
          <p v-html="$t('Datenpakete_GT_AGB_BegleitText')"></p>
          <b-form-checkbox
              id="AGB"
              v-model="agb"
              name="agb"
              value="accepted"
              unchecked-value="not_accepted">
            <span v-html="$t('Datenpakete_GT_AGB_CheckboxText')"></span>
          </b-form-checkbox>
          <b-alert show v-if="agb === 'not_accepted'" variant="danger">
            {{ $t("Datenpakete_GT_AGB_NichtAkzeptiert") }}
          </b-alert>
        </div>
        <div v-show="wizardStep === 3">
          <template>{{ $t("Datenpakete_GT_Speichere_Text") }}</template>
        </div>
        <div v-show="wizardStep === 4">
          <template>
            <p v-html="abschluss_text"></p>
          </template>
          <template v-if="ready4MoohAuslese">
            <span v-html="$t('weiterZuMoohAusleseText')"></span>
            <br/>
            <b-button v-on:click="closeGotoMoohAuslese" variant="primary">
              {{ $t("weiterZuMoohAusleseBtn") }}
            </b-button>
          </template>
        </div>
      </b-container>

      <div slot="modal-footer">
        <b-button v-show="wizardStep === 0" v-on:click="close" variant="secondary">
          {{ $t("Abbrechen") }}
        </b-button>
        <b-button variant="secondary" v-show="wizardStep > 0 && wizardStep < 3" v-on:click="zurueck">
          {{ $t("back") }}
        </b-button>&nbsp;
        <b-button show
                  v-show="wizardStep < 2" v-on:click="weiter" variant="primary"
                  :disabled="!anforderungenAusgefuellt(1)||rgsAnmeldungErzwingen">
          {{ $t("Weiter") }}
        </b-button>

        <b-button v-show="wizardStep === 2" :disabled="agb === 'not_accepted'" v-on:click="saveGT" variant="primary">
          {{ $t("Speichern") }}
        </b-button>
        <b-button v-show="wizardStep === 3" v-on:click="close" variant="primary">
          {{ $t("Abbrechen") }}
        </b-button>
        <b-button v-show="wizardStep === 4" v-on:click="close" variant="primary">
          {{ $t("close") }}
        </b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import moment from "moment";
import {bus} from "@/main";
import SelbstdeklarationZeile from "./SelbstdeklarationZeile.vue";

export default {
  name: "Selbstdeklaration",
  props: {
    initStep: {
      type: Number,
      default: 0,
    } /* wird von einladungen übersteuert */,
  },
  data() {
    return {
      agb: "not_accepted",
      wizardStep: 0,
      step: 0,
      abschluss_text: "",
      freigaben: [],
      rgs: {
        person: this.$t("Landwirt"),
        bForm: this.$t("Milchviehhaltung"),
        organisationen: [
          {de: 'Swiss Herdbook', fr: "Herdbook suisse", it: "Herdbook suisse"},
          {de: 'Holstein Switzerland', fr: "Holstein Switzerland", it: "Holstein Switzerland"},
          {de: 'Mutterkuh Schweiz', fr: "Vache mère Suisse", it: "Vache mère Suisse"},
          {de: 'Braunvieh Schweiz', fr: "Race brune Suisse", it: "Race brune Suisse"},
          {de: 'Swissbeef', fr: "Swissbeef", it: "Swissbeef"},
          {
            de: 'SMP-Produzentenorganisationen (VMMO, Aaremilch, ZMP, Prolait, MIBA, TMP, FSFL, Mittelland Milch, FTPL, LRG, FLV, VBMC)',
            fr: "Organisations de producteurs de lait de PSL (VMMO, Aaremilch, ZMP, Prolait, MIBA, TMP, FSFL, Mittelland Milch, FTPL, LRG, FLV, VBMC)",
            it: "Organisations de producteurs de lait de PSL (VMMO, Aaremilch, ZMP, Prolait, MIBA, TMP, FSFL, Mittelland Milch, FTPL, LRG, FLV, VBMC)"
          },
          {
            de: 'Sonstige (bitte unter Bemerkungen aufführen)',
            fr: "Autres (à mentionner dans les remarques)",
            it: "Autres (à mentionner dans les remarques)"
          }
        ],
        mitgliedschaften: [],
        tierarzt: {
          praxis: "",
          plz: "",
          ort: "",
        },
        bemerkungen: "",
        agb: false,
        angemeldet: false
      }
    };
  },
  computed: {
    checked: {
      get() {
        return this.$store.state.datenpaketeStore.gruenerTeppichSelected;
      },
      set(newValue) {
        this.$store.dispatch("setGruenerTeppichSelected", newValue);
      },
    },
    dataLoaded() {
      return this.$store.state.datenpaketeStore.pakete.length > 0;
    },
    paketGT() {
      return this.$store.state.datenpaketeStore.pakete.filter(
          (dpX) => dpX.id === this.$store.state.datenpaketeStore.GT.paketID
      )[0];
    },
    verwerter() {
      return this.paketGT.organisationen;
    },
    getTitle() {
      let title = " ..";
      switch (this.wizardStep) {
        case 0:
          title = this.$t("Datenpakete_GT_GA_Titel");
          break;
        case 1:
          title = this.$t("Datenpakete_GT_ZA_Titel");
          break;
        case 2:
          title = this.$t("Datenpakete_GT_FG_Titel");
          break;
        case 3:
          title = this.$t("Datenpakete_GT_Speichere_Titel");
          break;
        case 4:
          title = this.$t("Datenpakete_GT_Gespeichert_Titel");
          break;
      }
      return title;
    },
    agisID() {
      return this.$store.state.userStore.domain.agisID
    },
    email() {
      return this.$store.state.userStore.domain.email
    },
    adresse() {
      return this.$store.state.userStore.adresse.anrede + ' ' + this.$store.state.userStore.adresse.vorname + ' ' + this.$store.state.userStore.adresse.name
          + ', ' + this.$store.state.userStore.adresse.adresse + ', ' + this.$store.state.userStore.adresse.plz + ' ' + this.$store.state.userStore.adresse.ort
    },
    hasRGSAnmeldung(){
      return this.$store.state.datenpaketeStore.GT.hasRGSAnmeldung
    },
    ready4MoohAuslese() {
      return false
      /* let MOOH_ORG_ID = 107;
      let moohfreigabe = this.paketGT.organisationen.filter(
        (orgX) => orgX.orgid === MOOH_ORG_ID && orgX.freigabe === true
      );
      return moohfreigabe.length === 1; */
    },
    isBts() {
      return (
          this.paketGT.kriterien.filter(
              (kritX) => kritX.key === "BTS" && kritX.value > 0
          ).length > 0
      );
    },
    isRaus() {
      return (
          this.paketGT.kriterien.filter(
              (kritX) => kritX.key === "RAUS" && kritX.value > 0 && (kritX.value !== 7 || this.hasRGSAnmeldung)
          ).length > 0
      );
    },
    rgsAnmeldungErzwingen(){
      if(this.hasRGSAnmeldung){
        return false
      }
      return (
          this.paketGT.kriterien.filter(
              (kritX) => kritX.key === "RAUS" && kritX.value == 7 && !this.hasRGSAnmeldung
          ).length > 0
      );
    },
  },
  methods: {
    initModal() {
      this.wizardStep = this.initStep;
      this.agb = "not_accepted";
      this.rgs.mitgliedschaften = [];
      this.rgs.bemerkungen = "";
      this.rgs.tierarzt.praxis = "";
      this.rgs.tierarzt.plz = "";
      this.rgs.tierarzt.ort = "";
      this.rgs.agb = false;
    },
    scrollToTop() {
      this.$nextTick(async function () {
        //window.scrollTo(0,0); // scrollt das Hauptfenster im Hintergrund
        var element = document.getElementsByClassName("modal-title")[0];
        console.log(element);
        element.scrollIntoView(true);
        //element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      });
    },
    weiter() {
      this.wizardStep++;
      if (this.wizardStep === 1) {
        // bts und raus neu berechnen
        this.paketGT.kriterien.filter(
            (k) => k.key === "BTSundRAUS"
        )[0].value = this.isBts && this.isRaus ? 1 : -1;
      }
      this.scrollToTop();
    },
    zurueck() {
      this.wizardStep--;
      this.scrollToTop();
    },
    saveGT() {
      this.weiter();
      this.$store.dispatch("savePaket", {id: this.paketGT.id, declaration: true, approval: true});
    },
    async saveInProgressDone(paketID, errorMsg) {
      if (paketID !== this.paketGT.id) return;
      if (errorMsg.length > 1)
        this.abschluss_text =
            this.$t("Datenpakete_GT_FehlerBeimSpeichern_Text") + errorMsg;
      else this.abschluss_text = this.$t("Datenpakete_GT_Gespeichert_Text");
      // aktualisiert Status auf Paket
      this.$store.commit("setGTValue", {
        id: 23,
        key: "GruenerTeppich",
        value: (this.anforderungenStatus(1) === true && this.anforderungenStatus(2) === true) ? 1 : -1
      });
      // aktualisiert den disabled-Status der Organisationen
      this.$store.commit("setGTDisabled");
      this.$store.dispatch("loadUngelesen");
      await this.$store.dispatch("einladungenGTfinished", this.verwerter);
      this.weiter();
    },
    close() {
      this.$root.$emit("bv::hide::modal", "selbstdeklarationGTmodal");
    },
    anforderungen(art) {
      let filteredAnforderungen = this.paketGT.kriterien.filter((kritX) => kritX.art === art);
      return filteredAnforderungen
    },
    anforderungenAnzahl(art) {
      let anzahl = this.paketGT.kriterien.filter(
          (kritX) => kritX.art === art && kritX.value > 0 && kritX.key !== "RAUS"
      ).length;
      if (art === 1 && !this.isBts && this.isRaus) {
        // Entweder BTS oder RAUS
        anzahl++;
      }
      return anzahl;
    },
    // der Leerzustand(0) ist nicht erlaubt
    anforderungenAusgefuellt(art) {
      let test = this.paketGT.kriterien.filter(
          (kritX) => kritX.art === art && kritX.value === null
      ); /* null ist vom Typ object */
      return test.length <= 0;
    },
    anforderungenTotal(art) {
      return art === 2 ? 2 : 10;
    },
    anforderungenStatus(art) {
      return this.anforderungenAnzahl(art) >= this.anforderungenTotal(art);
    },
    freigabeChanged(orgid, indx) {
      this.$store.dispatch("setFreigabeChanged", {orgid: orgid, indx: indx});
    },
    convertTime(value) {
      return moment(value).format("DD.MM.YYYY");
    },
    jumpStep(step) {
      this.wizardStep = step;
    },
    closeGotoMoohAuslese() {
      //this.close() //schliesst den GT
      this.$root.$emit("bv::hide::modal", "selbstdeklarationGTmodal");
      this.$root.$emit("bv::show::modal", "selbstdeklarationMAmodal", 4);
    },
    async sendAnmeldungRGS() {
      this.$store.dispatch("sendAnmeldungRGS", {
        mitgliedschaften: this.rgs.mitgliedschaften,
        bemerkungen: this.rgs.bemerkungen,
        tierarzt: this.rgs.tierarzt
      });
    },
  },
  components: {
    "selbstdeklaration-zeile": SelbstdeklarationZeile,
  },
  created() {
  },
  mounted() {
    let self = this;
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId === "selbstdeklarationGTmodal") {
        this.initModal();
      }
    });
    bus.$on("paketSaved", self.saveInProgressDone);
    bus.$on("GTjumpStep", self.jumpStep);
  },
  updated() {
  },
};
</script>

<style scoped>
.active {
  font-weight: bold;
}
</style>
